export default {
  title: 'Production Lines',
  description: 'Industrial production lines management',
  noResults: 'No production lines found',
  viewDetails: 'View Details',
  incidents: 'incident(s)',
  actions: 'action(s)',
  stats: {
    total: 'Total Lines',
    running: 'Running',
    avgOee: 'Avg OEE',
    producedToday: 'Produced Today'
  },
  filters: {
    status: 'Status',
    type: 'Type'
  },
  status: {
    running: 'Running',
    stopped: 'Stopped',
    maintenance: 'Maintenance',
    error: 'Error'
  },
  type: {
    assembly: 'Assembly',
    machining: 'Machining',
    packaging: 'Packaging',
    preparation: 'Preparation',
    quality_control: 'Quality Control'
  },
  metrics: {
    speed: 'Speed',
    quality: 'Quality',
    produced: 'Produced',
    defects: 'Defects'
  }
}
